import { Suspense, useEffect } from "react";
import graphql from "babel-plugin-relay/macro";
import { useLazyLoadQuery } from "react-relay";
import ProjectCardSmall from "./ProjectCardSmall";
import { CircularProgress, Grid } from "@mui/material";
import ReactGA from "react-ga4";

const ProjectsQuery = graphql`
    query ProjectsQuery {
        projects {
            ...ProjectCardSmall_project
        }
    }
`;

function ProjectsList() {
    const data = useLazyLoadQuery(ProjectsQuery, {});
    return (
        <Grid container spacing={2}>
            {data.projects.map((project, i) => (
                <Grid item key={i} xs={12} sm={6} md={4}>
                    <ProjectCardSmall projectRef={project} />
                </Grid>
            ))}
        </Grid>
    );
}

function Projects(_props) {
    useEffect(() => {
        document.title = "Projects - DavidAdkins.com";
        if (process.env.NODE_ENV !== "test") {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname });
        }
    });

    return (
        <Suspense fallback={<CircularProgress />}>
            <ProjectsList />
        </Suspense>
    );
}

export default Projects;
